import { getCache, setCache } from '@voghion/native-api'
import { getScrollTop } from '@voghion/fe-util'
import { getLocalStorage } from '@voghion/fe-util'

const windowScrollKey = 'windowScroll'

/**
 * 缓存窗口滚动高度
 */
export const saveWindowScrollTop = () => {
  setCache({
    key: windowScrollKey,
    value: getScrollTop() + ''
  })
}

/**
 * 缓存窗口滚动高度
 */
export const revertWindowScrollTop = () => {
  getCache({
    key: windowScrollKey
  }).then((res) => {
    if (!res.error && res.data.value) {
      window.scrollTo(0, parseFloat(res.data.value))
    }
  })
}

const imRoomsCacheKey = 'zoomies_rooms'

/**
 * 缓存房间列表
 * @param rooms
 */
export const cacheRooms = (rooms: any) => {
  const storage = getLocalStorage()
  if (!rooms) {
    storage.removeItem(imRoomsCacheKey)
  } else {
    storage.setItem(imRoomsCacheKey, rooms)
  }
}

/**
 * 获取已缓存的房间列表
 * @returns
 */
export const getCacheRooms = () => {
  const storage = getLocalStorage()
  return storage.getItem(imRoomsCacheKey)
}
